import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { ListTitle } from './TrlListTitle.styles';

export const TrlListTitle = ({ title, hasBiggerTitle, hasMarginTop }) => (
  <ListTitle hasBiggerTitle={hasBiggerTitle} hasMarginTop={hasMarginTop}>
    <FormattedMessage id={title} />
  </ListTitle>
);

TrlListTitle.propTypes = {
  title: PropTypes.string.isRequired,
  hasBiggerTitle: PropTypes.bool,
  hasMarginTop: PropTypes.bool,
};
